
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
//==================|| AXIOS CONFIGURATION ||============//
export const instance: AxiosInstance = axios.create({
  baseURL: 'https://devdemoapi.shareplan.com.sg/v1/api/'
  // baseURL: 'https://localhost:7230/api/'
})

instance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if(localStorage.getItem("tempauthtoken") != null) {
      const token: string | '' = localStorage.getItem("tempauthtoken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }else {
      const token: string | '' = localStorage.getItem("authtoken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response)=>{
    return response
  },
  (error)=>{
    return Promise.reject(error)
  }
)

export const unrouteinstance: AxiosInstance = axios.create({
  baseURL: 'https://devdemoapi.shareplan.com.sg/v1/api/'
  // baseURL: 'https://localhost:7230/api/'
})
